import '@/assets.best-books/styles.scss'
import '@/assets.best-books/fontawesome/fontawesome-pro-5.12.0-web/css/all.min.css'

// Manages public page navbar toggling on small screen.
// eslint-disable-next-line import/no-unassigned-import
import '@/assets.best-books/bootstrap/js/collapse.js'
import { initPageBestBooks } from '@/pages-best-books/init'

initPageBestBooks()
